import request from '@/router/axios'

function fetchEnrollScopes() {
  return request({
    url: '/admin/admin/member/organization-tag/all',
    method: 'get',
  })
}

function createActivity(params) {
  return request({
    url: '/activity/admin/activity',
    method: 'POST',
    data: params
  })
}

function editActivity(params) {
  return request({
    url: '/activity/admin/activity',
    method: 'PUT',
    data: params
  })
}

function checkActivityIsUpdated(params) {
  return request({
    url: '/activity/admin/activity/check-is-updated',
    method: 'POST',
    data: params
  })
}

function publishActivity(id, params) {
  return request({
    url: `/activity/admin/activity/${id}/publish`,
    method: 'PUT',
    params,
  })
}

function pullDownActivity(id, params) {
  return request({
    url: `/activity/admin/activity/${id}/down`,
    method: 'PUT',
    params,
  })
}

function republishActivity(id, params) {
  return request({
    url: `/activity/admin/activity/${id}/republish`,
    method: 'PUT',
    params,
  })
}

function getActivityMiniProgramCode(id) {
  return request({
    url: `/activity/admin/activity/mini-program-code/${id}`,
    method: 'GET',
  })
}

function createActivityProject(data) {
  return request({
    url: '/activity/admin/activity/projects',
    method: 'POST',
    data,
  })
}

function removeActivityProject(id, reason) {
  return request({
    url: '/activity/admin/activity/projects/' + id,
    method: 'DELETE',
    params: {
      reason: reason
    }
  });
}

function editActivityProject(data) {
  return request({
    url: '/activity/admin/activity/projects',
    method: 'PUT',
    data,
  })
}

function getProjectRelatedQuestionnaireIds() {
  return request({
    url: '/activity/admin/activity/projects/related-questionnaire-ids',
    method: 'GET',
  })
}

function inviteMember(projectId, inviteMemberUnionIds) {
  return request({
    url: `/activity/admin/activity/projects/${projectId}/invite-member/${inviteMemberUnionIds}`,
    method: 'PUT',
  })
}

function sendCourseReminder(projectId) {
  return request({
    url: `/activity/admin/activity/projects/${projectId}/send-course-reminder`,
    method: 'POST',
  })
}

function getActivityProjectCheckinMiniProgramCode(id) {
  return request({
    url: `/activity/admin/activity/projects/checkin-mini-program-code/${id}`,
    method: 'GET',
  })
}

function exportActivityEnrollmentCheckIn(params) {
  return request({
    url: '/activity/admin/activity/enrollment/export/checkin',
    method: 'GET',
    params,
  })
}

function exportActivityEnrollmentMember(params) {
  return request({
    url: '/activity/admin/activity/enrollment/export/member',
    method: 'GET',
    params,
  })
}

function isAllowDeleteActivityProjectGroup(id) {
  return request({
    url: `/activity/admin/activity/project-group/allow-delete/${id}`,
    method: 'GET',
  })
}

function approveActivityEnrollment(params) {
  return request({
    url: '/activity/admin/activity/enrollment/approve',
    method: 'POST',
    params,
  })
}

function rejectActivityEnrollment(params) {
  return request({
    url: '/activity/admin/activity/enrollment/reject',
    method: 'POST',
    params,
  })
}

function enrollmentPriorityQueuing(enrollmentId) {
  return request({
    url: `/activity/admin/activity/enrollment/priority-queuing/${enrollmentId}`,
    method: 'PUT',
  })
}

function deleteActivityEnrollment(enrollmentId, reason) {
  return request({
    url: `/activity/admin/activity/enrollment/${enrollmentId}`,
    method: 'DELETE',
    params: {
      reason,
    }
  })
}

function sendMassMessage(data) {
  return request({
    url: '/activity/admin/activity-msg/mass-message',
    method: 'POST',
    data,
  })
}

function removeMcActivity(id) {
  return request({
    url: '/activity/admin/activity/' + id,
    method: 'delete'
  });
}

function getActivity (id) {
  return request({
    url: '/activity/admin/activity/' + id,
    method: 'get'
  })
}

function getActivityProjectByActivty (id) {
  return request({
    url: '/activity/admin/activity/projects/by-activity/' + id,
    method: 'get'
  })
}

function fetchMcActivityEnrollmentList(params) {
  return request({
    url: '/activity/admin/activity/enrollment/page',
    method: 'get',
    params
  })
}

function fetchMcActivityList(params) {
  return request({
    url: '/activity/admin/activity/page',
    method: 'get',
    params
  })
}
 
function getAllActivityTypes(params) {
  return request({
    url: '/activity/admin/activity-type/list',
    method: 'GET',
    params,
  });
}
 
function getActivityTypeList(params) {
  return request({
    url: '/activity/admin/activity-type/page',
    method: 'GET',
    params,
  });
}

function addActivityType(data) {
  return request({
    url: '/activity/admin/activity-type',
    method: 'POST',
    data,
  });
}

function editActivityType(id, data) {
  return request({
    url: `/activity/admin/activity-type/${id}`,
    method: 'PUT',
    data,
  });
}

function removeActivityType(id) {
  return request({
    url: `/activity/admin/activity-type/${id}`,
    method: 'DELETE',
  });
}

function checkIsRelateProject(params) {
  return request({
    url: '/activity/admin/activity/projects/check-questionnaire-relate',
    method: 'GET',
    params
  })
}

function fetchActivityBlacklist(params) {
  return request({
    url: '/activity/admin/activity/blacklist/page',
    method: 'GET',
    params
  })
}

function exportActivityBlacklist(params) {
  return request({
    url: '/activity/admin/activity/blacklist/export',
    method: 'GET',
    params,
  })
}

function manuallyUnfreezeActivityBlacklist(data) {
  return request({
    url: '/activity/admin/activity/blacklist/manually-unfreeze',
    method: 'POST',
    data,
  });
}

export default {
  fetchEnrollScopes,
  createActivity,
  editActivity,
  checkActivityIsUpdated,
  publishActivity,
  pullDownActivity,
  republishActivity,
  getActivityMiniProgramCode,
  createActivityProject,
  removeActivityProject,
  editActivityProject,
  getProjectRelatedQuestionnaireIds,
  inviteMember,
  sendCourseReminder,
  getActivityProjectCheckinMiniProgramCode,
  exportActivityEnrollmentCheckIn,
  exportActivityEnrollmentMember,
  isAllowDeleteActivityProjectGroup,
  approveActivityEnrollment,
  rejectActivityEnrollment,
  deleteActivityEnrollment,
  sendMassMessage,
  removeMcActivity,
  getActivity,
  getActivityProjectByActivty,
  fetchMcActivityEnrollmentList,
  fetchMcActivityList,
  getAllActivityTypes,
  getActivityTypeList,
  addActivityType,
  editActivityType,
  removeActivityType,
  enrollmentPriorityQueuing,
  checkIsRelateProject,
  fetchActivityBlacklist,
  exportActivityBlacklist,
  manuallyUnfreezeActivityBlacklist,
};